'use client';

import { c as _c } from "react/compiler-runtime";
import NumberFlow from '@number-flow/react';
import { useLocale } from 'next-intl';
import { TRPC_SETTINGS } from '~/constants/trpc';
import type { Locale } from '~/i18n/i18n-config';
import { api } from '~/libs/api';
import { useTripBookingStore } from '~/stores/tpv2/tripBookingStore';
type AnimatedPriceProps = {
  amountGBP: number;
  showDecimals?: boolean;
  className?: string;
};
export const AnimatedPrice = t0 => {
  const $ = _c(18);
  const {
    amountGBP,
    showDecimals: t1,
    className
  } = t0;
  const showDecimals = t1 === undefined ? false : t1;
  const locale = useLocale() as Locale;
  const displayCurrency = useTripBookingStore(_temp);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    data: exchangeRates
  } = api.account.getCurrentExchangeRates.useQuery(t2, TRPC_SETTINGS.QUERY_NO_REFETCH);
  let t3;
  if ($[1] !== displayCurrency || $[2] !== exchangeRates?.exchangeRates) {
    t3 = displayCurrency === "GBP" ? 1 : exchangeRates?.exchangeRates.find(r => r.quoteCurrency === displayCurrency)?.exchangeRate;
    $[1] = displayCurrency;
    $[2] = exchangeRates?.exchangeRates;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const rate = t3;
  if (rate === undefined) {
    let t4;
    if ($[4] !== className) {
      t4 = <span className={className} aria-hidden={true} />;
      $[4] = className;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  const convertedAmount = amountGBP * rate;
  let t4;
  if ($[6] !== convertedAmount || $[7] !== showDecimals) {
    t4 = showDecimals ? Math.round(convertedAmount * 100) / 100 : Math.round(convertedAmount);
    $[6] = convertedAmount;
    $[7] = showDecimals;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const displayAmount = t4;
  const t5 = showDecimals ? 2 : 0;
  const t6 = showDecimals ? 2 : 0;
  let t7;
  if ($[9] !== displayCurrency || $[10] !== t5 || $[11] !== t6) {
    t7 = {
      style: "currency",
      currency: displayCurrency,
      minimumFractionDigits: t5,
      maximumFractionDigits: t6,
      useGrouping: true,
      currencyDisplay: "symbol"
    };
    $[9] = displayCurrency;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== className || $[14] !== displayAmount || $[15] !== locale || $[16] !== t7) {
    t8 = <NumberFlow value={displayAmount} locales={locale} format={t7} className={className} />;
    $[13] = className;
    $[14] = displayAmount;
    $[15] = locale;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
function _temp(s) {
  return s.displayCurrency;
}